import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LibMusStudies = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.075 39.272H39.18v-22.38h3.995c.4 0 .7-.3.799-.599.1-.4-.1-.8-.4-.9L22.4 3.106c-.3-.1-.6-.1-.8 0L.427 15.294c-.3.2-.5.6-.4.9.1.399.4.599.799.599H4.82v22.379H.925c-.5 0-.8.4-.8.8-.099.599.3.998.8.998h42.25c.5 0 .799-.4.799-.799 0-.5-.4-.9-.899-.9ZM4.021 15.194 22 4.804l17.979 10.39H4.02Zm8.39 24.078H6.518v-22.38h5.893v22.38Zm17.48 0H14.109v-22.38h15.882v22.38h-.1Zm7.59 0H31.59v-22.38h5.893v22.38Z"
  }));
});
LibMusStudies.displayName = 'LibMusStudies';
LibMusStudies.defaultProps = {
  'aria-label': 'LibMusStudies'
};
export default LibMusStudies;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/LibMusStudies.js
// module id = 3032
// module chunks = 11